import React, { useEffect } from "react";
import { useLocation, NavLink } from "react-router-dom";
import Highlights from "../Component/Highlights";
import { Link } from "react-router-dom";
import LazyLoad from "react-lazyload";
const Header = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  const handleCloseNavbar = () => {
    const navbarCollapse = document.getElementById("main_nav");
    if (navbarCollapse.classList.contains("show")) {
      navbarCollapse.classList.remove("show");
    }
  };
  return (
    <>
      <div className="header">
        <div className="logo">
          <LazyLoad>
            <NavLink to="/">
              <img
                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/logo.png"
                alt="Cannosa school"
                className="img-fluid"
              />
            </NavLink>
          </LazyLoad>
        </div>
        <div className="header-nav">
          <Highlights />
          <nav className="navbar navbar-expand-lg">
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#main_nav"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="main_nav">
              <div className="closeMain" onClick={handleCloseNavbar}>
                <i class="bi bi-x"></i>
              </div>
              <ul className="navbar-nav">
                <li className="nav-item active" onClick={handleCloseNavbar}>
                  {" "}
                  <Link to="/">
                    <i className="bi bi-house-door-fill"></i>
                  </Link>
                </li>
                <li className="nav-item dropdown">
                  <div className="nav-link" data-bs-toggle="dropdown">
                    About Us{" "}
                  </div>
                  <ul className="dropdown-menu fade-up">
                    <li>
                      <NavLink
                        className="dropdown-item"
                        to="/about"
                        onClick={handleCloseNavbar}
                      >
                        {" "}
                        School History
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className="dropdown-item"
                        to="/aimObj"
                        onClick={handleCloseNavbar}
                      >
                        {" "}
                        Aims & Objective{" "}
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className="dropdown-item"
                        to="/cbseInfo"
                        onClick={handleCloseNavbar}
                      >
                        {" "}
                        CBSE Information
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className="dropdown-item"
                        to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/pdf/self-affit.pdf"
                        target="_blank"
                        onClick={handleCloseNavbar}
                      >
                        {" "}
                        Self Affidavit of School
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className="dropdown-item"
                        to="/visionmission"
                        onClick={handleCloseNavbar}
                      >
                        {" "}
                        Vision & Mission
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className="dropdown-item"
                        to="/manager"
                        onClick={handleCloseNavbar}
                      >
                        {" "}
                        Manager's Message
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className="dropdown-item"
                        to="/principal"
                        onClick={handleCloseNavbar}
                      >
                        {" "}
                        Principal's Message
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className="dropdown-item"
                        to="/headgirl"
                        onClick={handleCloseNavbar}
                      >
                        {" "}
                        Head Girl's Message
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className="dropdown-item"
                        to="/headboy"
                        onClick={handleCloseNavbar}
                      >
                        {" "}
                        Head Boys's Message
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className="dropdown-item"
                        to="/smc"
                        onClick={handleCloseNavbar}
                      >
                        {" "}
                        School Managing Committee
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className="dropdown-item"
                        to="/schoolAnthem"
                        onClick={handleCloseNavbar}
                      >
                        {" "}
                        School Anthem
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className="dropdown-item"
                        to="/schoolPrayer"
                        onClick={handleCloseNavbar}
                      >
                        {" "}
                        School Prayer
                      </NavLink>
                    </li>
                  </ul>
                </li>
                <li className="nav-item dropdown">
                  <div className="nav-link" data-bs-toggle="dropdown">
                    Facilities{" "}
                  </div>
                  <ul className="dropdown-menu fade-up">
                    <li>
                      <NavLink
                        className="dropdown-item"
                        to="/library"
                        onClick={handleCloseNavbar}
                      >
                        {" "}
                        Library
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className="dropdown-item"
                        to="/laboratory"
                        onClick={handleCloseNavbar}
                      >
                        {" "}
                        Laboratories{" "}
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className="dropdown-item"
                        to="/music"
                        onClick={handleCloseNavbar}
                      >
                        {" "}
                        Music
                      </NavLink>
                    </li>
                  </ul>
                </li>
                <li className="nav-item dropdown">
                  <div className="nav-link" data-bs-toggle="dropdown">
                    Academic{" "}
                  </div>
                  <ul className="dropdown-menu fade-up">
                    <li>
                      <NavLink
                        className="dropdown-item"
                        to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/pdf/Academic-Calendar.pdf"
                        target="_blank"
                        onClick={handleCloseNavbar}
                      >
                        {" "}
                        Academic Calendar
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className="dropdown-item"
                        to="/classActivity"
                        onClick={handleCloseNavbar}
                      >
                        {" "}
                        Class Activities
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className="dropdown-item"
                        to="/games"
                        onClick={handleCloseNavbar}
                      >
                        {" "}
                        Games/ CCA
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className="dropdown-item"
                        to="/uniform"
                        onClick={handleCloseNavbar}
                      >
                        {" "}
                        School Uniform
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className="dropdown-item"
                        to="/ptm"
                        onClick={handleCloseNavbar}
                      >
                        {" "}
                        PTM
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className="dropdown-item"
                        to="/rulesReg"
                        onClick={handleCloseNavbar}
                      >
                        {" "}
                        Rules & Regulation
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className="dropdown-item"
                        to="/withdrawal"
                        onClick={handleCloseNavbar}
                      >
                        {" "}
                        Withdrawal & Dismissal
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className="dropdown-item"
                        to="/parentCorner"
                        onClick={handleCloseNavbar}
                      >
                        {" "}
                        Parents Corner
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className="dropdown-item"
                        to="/assessmentsPromo"
                        onClick={handleCloseNavbar}
                      >
                        {" "}
                        Assessments and Promotion
                      </NavLink>
                    </li>
                  </ul>
                </li>
                <li className="nav-item dropdown">
                  <div className="nav-link" data-bs-toggle="dropdown">
                    Office Bearers{" "}
                  </div>
                  <ul className="dropdown-menu fade-up">
                    <li>
                      <NavLink
                        className="dropdown-item"
                        to="/ourPrincipals"
                        onClick={handleCloseNavbar}
                      >
                        {" "}
                        Our Principals
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className="dropdown-item"
                        to="/staffPhotos"
                        onClick={handleCloseNavbar}
                      >
                        {" "}
                        Staff Photos
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className="dropdown-item"
                        to="/schoolCabinet"
                        onClick={handleCloseNavbar}
                      >
                        {" "}
                        School Cabinet
                      </NavLink>
                    </li>
                  </ul>
                </li>
                <li className="nav-item" onClick={handleCloseNavbar}>
                  {" "}
                  <Link to="/mandatoryDisclosure">CBSE Disclosure</Link>
                </li>
                <li className="nav-item dropdown">
                  <div className="nav-link" data-bs-toggle="dropdown">
                    Admission{" "}
                  </div>
                  <ul className="dropdown-menu fade-up">
                    <li>
                      <NavLink
                        className="dropdown-item"
                        to="/fee"
                        onClick={handleCloseNavbar}
                      >
                        {" "}
                        School Fee
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className="dropdown-item"
                        to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/pdf/Book-list.pdf"
                        target="_blank"
                        onClick={handleCloseNavbar}
                      >
                        {" "}
                        List of Books
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className="dropdown-item"
                        to="/attendanceLeaveAbsence"
                        onClick={handleCloseNavbar}
                      >
                        Attendance, Leave & Absence
                      </NavLink>
                    </li>
                  </ul>
                </li>
                <li className="nav-item dropdown">
                  <div className="nav-link" data-bs-toggle="dropdown">
                    Gallery{" "}
                  </div>
                  <ul className="dropdown-menu fade-up">
                    <li>
                      <NavLink
                        className="dropdown-item"
                        to="/photoGallery"
                        onClick={handleCloseNavbar}
                      >
                        {" "}
                        Photo Gallery
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className="dropdown-item"
                        to="/videoGallery"
                        onClick={handleCloseNavbar}
                      >
                        Video Gallery
                      </NavLink>
                    </li>
                  </ul>
                </li>
                {/* <li className="nav-item" onClick={handleCloseNavbar}> <Link to="/photoGallery">Gallery</Link></li>                                 */}
                <li className="nav-item" onClick={handleCloseNavbar}>
                  {" "}
                  <Link to="/contact">Contact</Link>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </div>
    </>
  );
};

export default Header;
